<div class="container">

	<div class="close-container">
		<div class="flex row start center g-6">
			<h4>{{ 'general.edit' | translateWithKeys }}</h4><h4>{{ (mediaTypeToString[model?.fileType] | translateWithKeys) }}</h4>
		</div>
		<div class="flex row end w-100">
			<mat-icon class="close-icon flex row end" (click)="close()">close</mat-icon>
		</div>
	</div>
	<div class="flex row player-container gap">
		<div class="w-70" [ngClass]="{ 'flex row center': model?.fileType === MediaFileType.IMAGE }">
			@switch(model?.fileType) {
				@case (MediaFileType.VIDEO) {
					<app-video-player [videoUrl]="model?.videoHls || model?.video" [videoId]="model?.id" [subtitles]="model?.__subtitles"></app-video-player>
				}
				@case (MediaFileType.PDF) {
					<app-pdf-viewer [src]="model?.video"></app-pdf-viewer>
				}
				@case (MediaFileType.IMAGE) {
					<img [src]="model?.video" class="image-viewer">
				}
				@default {
					<h5 class="text-warn">{{ 'general.error_playing_media' | translateWithKeys }}</h5>
				}
			}
		</div>
		<div class="flex column w-30">
			<mat-form-field appearance="outline">
				<input type="text" matInput [(ngModel)]="model.fileName" (blur)="confirmFileName(model)">
			</mat-form-field>
			<mat-form-field appearance="outline">
				<textarea
				  matInput
				  cdkTextareaAutosize
				  #autosize="cdkTextareaAutosize"
				  cdkAutosizeMinRows="4"
				  cdkAutosizeMaxRows="20"
				  [placeholder]="'general.description' | translateWithKeys"
				  [(ngModel)]="model.description">
				</textarea>
			  </mat-form-field>

		</div>
	</div>
	<div class="flex row space-between w-100 gap">
		<button mat-stroked-button class="button" (click)="close()">
			{{ 'general.cancel' | translateWithKeys }}
		</button>
		<button mat-flat-button class="button w-fit bg-primary-darker text-accent-lighter" (click)="save()">
			{{ 'general.save_changes' | translateWithKeys }}
		</button>
	</div>
</div>

<ng-template #language>
	<mat-chip class="grey-chip" (click)="editLanguage()">{{ model?.language?.name | translateWithKeys}}</mat-chip>
	<div class="column">
		@if(openLanguages){
			<div class="container-languages bg-accent-lighter">
				<div class="search-bar-container">
					<app-search-bar (searchString)="searchInLanguges($event)" placeholder="general.search"></app-search-bar>
				</div>

				@for (lang of filteredLanguages; track $index) {
					<mat-option (click)="selectLanguage(lang)">
						<span>{{lang.name | translateWithKeys}} </span>
					</mat-option>
				}
			</div>
		}
	</div>
</ng-template>
